// @flow
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import styled from 'styled-components';
import ReactModal from 'react-modal';

import { colors, modalStyles } from '../../shared/styles';

import Geolocation from '../shared/forms/Geolocation';
import S3Upload from '../shared/forms/S3Upload';
import Select from '../shared/forms/Select';
import TextArea from '../shared/forms/TextArea';

import Loader from '../../components/Loader/Loader';

const StyledAddRemoveToLetBoardModal = styled(ReactModal)`
    max-width: 680px;
    margin: 40px auto 0 auto;
    background: ${colors.white};
    border-radius: 4px;

    & .title {
        padding: 10px 20px;
        border-bottom: 1px solid ${colors.offWhite};
    }

    & .title h3 {
        margin: 0;
    }

    & .actions {
        text-align: right;
        padding: 10px;
        border-top: 1px solid ${colors.offWhite};
    }

    & .actions button {
        padding: 5px 10px;
        border: 0;
        border-radius: 4px;
        margin-left: 10px;
        font-size: 14px;
    }

    & .actions button[disabled] {
        opacity: 0.5;
    }

    & .actions .primary {
        background: ${colors.orange.default};
        color: ${colors.white};
    }

    & .actions .secondary {
        background: ${colors.offWhite};
        color: ${colors.grey.default};
    }

    & .content {
        min-height: 200px;
        background: #edf1f2;
        overflow-y: scroll;
        max-height: calc(100vh - 200px);
    }

    & .content p.intro {
        padding: 0 20px 16px;
        margin-bottom: 0;
        border-bottom: 1px solid ${colors.offWhite};
    }

    & .content .row {
        display: flex;
    }

    & .content .col {
        flex: 1;
    }

    & .content .details {
        padding: 10px 20px;
    }

`;

export const validate = (values: Object) => {
    const errors = {};

    if (!values.instructionType || values.instructionType.length < 1) {
        errors.instructionType = 'Instruction type is required';
    }

    if (!values.boardType || values.boardType.length < 1) {
        errors.boardType = 'Board type is required';
    }

    if (!values.boardPlacement || values.boardPlacement.length < 1) {
        errors.boardPlacement = 'Board placement is required';
    }

    if (!values.keyRequired || values.keyRequired.length < 1) {
        errors.keyRequired = 'Specify if a key is required';
    } else if (
        values.keyRequired === 'YES' &&
        (!values.keyDetails || values.keyDetails.length < 1)
    ) {
        errors.keyDetails = 'Please supply details';
    }

    if (
        !values.geolocation ||
        !values.geolocation.lat ||
        !values.geolocation.lng
    ) {
        errors.geolocation = 'Please specifiy a location';
    }

    return errors;
};

let AddRemoveToLetBoardForm = (props: any) => {
    const {
        handleSubmit,
        keyRequired,
        submitting,
        onCancel,
        propertyReference,
        propertyAddress,
        labels,
    } = props;

    // const { generating, generated, matches, downloadUrl } = exportState;

    return (
        <form onSubmit={handleSubmit}>
            <div className="content">
                <div className="row">
                    <div className="col">
                        <p className="details">
                            <b>Reference:</b> {propertyReference}
                            <br />
                            <b>Address:</b> {propertyAddress}
                        </p>
                    </div>

                    <div className="col">
                        <Field
                            name="instructionType"
                            label="Instruction Type"
                            component={Select}
                            disabled={submitting}
                        >
                            <option value="">Please select...</option>
                            {Object.keys(labels.instructions).map(value => {
                                return (
                                    <option key={value} value={value}>
                                        {labels.instructions[value]}
                                    </option>
                                );
                            })}
                        </Field>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <Field
                            name="boardType"
                            label="Board Type"
                            component={Select}
                            disabled={submitting}
                        >
                            <option value="">Please select...</option>
                            {Object.keys(labels.type).map(value => {
                                return (
                                    <option key={value} value={value}>
                                        {labels.type[value]}
                                    </option>
                                );
                            })}
                        </Field>

                        <Field
                            name="additionalWording"
                            label="Additional Wording"
                            component={TextArea}
                            disabled={submitting}
                        />
                    </div>

                    <div className="col">
                        <Field
                            name="boardPlacement"
                            label="Board Placement"
                            component={Select}
                            disabled={submitting}
                        >
                            <option value="">Please select...</option>
                            {Object.keys(labels.placement).map(value => {
                                return (
                                    <option key={value} value={value}>
                                        {labels.placement[value]}
                                    </option>
                                );
                            })}
                        </Field>

                        <Field
                            name="specificFixingInstructions"
                            label="Specific Fixing Instructions"
                            component={TextArea}
                            disabled={submitting}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <Field
                            name="keyRequired"
                            label="Is Key Required"
                            component={Select}
                            disabled={submitting}
                        >
                            <option value="">Please select...</option>
                            <option value="YES">Yes</option>
                            <option value="NO">No</option>
                        </Field>
                    </div>

                    <div className="col">
                        <Field
                            name="keyDetails"
                            label="Please supply details"
                            component={TextArea}
                            disabled={keyRequired !== 'YES' || submitting}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <Field
                            name="geolocation"
                            label="Location"
                            component={Geolocation}
                            disabled={submitting}
                            mapHeight={200}
                            hideLocateButton
                        />
                    </div>

                    <div className="col">
                        <Field
                            name="locationDescription"
                            label="Location Description (optional)"
                            component={TextArea}
                            disabled={submitting}
                        />

                        <Field
                            name="photoAsset"
                            accept="image/gif, image/jpeg"
                            assetType="toletboard.image"
                            maxFileSize={1024 * 1024 * 2}
                            component={S3Upload}
                            disabled={submitting}
                            selectText="Select a photo to upload..."
                        />
                    </div>
                </div>
            </div>

            <div className="actions">
                <button
                    className="secondary"
                    disabled={submitting}
                    onClick={onCancel}
                    type="button"
                >
                    Cancel
                </button>

                <button className="primary" disabled={submitting}>
                    {submitting ? 'Saving...' : 'Save'}
                </button>
            </div>
        </form>
    );
};

AddRemoveToLetBoardForm = reduxForm({
    form: 'propertyAddRemoveToLetBoard',
    validate,
})(AddRemoveToLetBoardForm);

const selector = formValueSelector('propertyAddRemoveToLetBoard');

const mapStateToProps = state => {
    return {
        keyRequired: selector(state, 'keyRequired'),
        labels: state.toletboards.shared,
    };
};

AddRemoveToLetBoardForm = connect(mapStateToProps)(AddRemoveToLetBoardForm);

const AddRemoveToLetBoardModal = (props: any) => {
    const { onCancel, onSubmit, isOpen, data } = props;

    const isFetching = data.property.fetching === true;
    const property = data && data.property ? data.property.detail : null;

    let initialValues = {};

    if (!isFetching && property) {
        initialValues = {
            propertyId: property.propertyId,
            geolocation:
                property.propertyLat && property.propertyLong
                    ? {
                          lat: property.propertyLat,
                          lng: property.propertyLong,
                      }
                    : {
                          lat: 54.00366,
                          lng: -2.547855,
                      },
        };
    }

    return (
        <StyledAddRemoveToLetBoardModal
            contentLabel="Add/Remove To Let Board"
            shouldCloseOnOverlayClick={false}
            closeTimeoutMS={200}
            isOpen={isOpen}
            style={modalStyles}
        >
            <div className="title">
                <h3>Add/Remove To Let Board</h3>
            </div>

            {isFetching &&
                <div>
                    <div className="content">
                        <Loader message="Loading property, please wait..." />
                    </div>
                </div>}
            {!isFetching &&
                property &&
                <AddRemoveToLetBoardForm
                    onCancel={onCancel}
                    onSubmit={onSubmit}
                    initialValues={initialValues}
                    propertyReference={property.propertyReference}
                    propertyAddress={property.propertyAddress}
                />}
        </StyledAddRemoveToLetBoardModal>
    );
};

export default AddRemoveToLetBoardModal;



// WEBPACK FOOTER //
// ./src/components/PropertyForms/AddRemoveToLetBoardModal.js